import * as http from 'utils/http';
import { cancel, cancelled, call, fork, put, take, takeLatest } from 'redux-saga/effects';

import config from 'config';
import history from 'modules/history';
import { pushWithQuery as push, replaceWithQuery as replace } from 'utils/routing';

import {
  cancelSingle,
  doneSingle,
  removeSingle,
  requestSingle,
  doneActiveOrders,
  requestActiveOrders,
  cancelRequestActiveOrders,
} from './duck';

// @effect Action
const openEditModal$ = 'recurringOrders/openEditModal$';
const closeEditModal$ = 'recurringOrders/closeEditModal$';
const openDetailModal$ = 'recurringOrders/openDetailModal$';
const closeDetailModal$ = 'recurringOrders/closeDetailModal$';
const fetchRecurringOrder$ = 'recurringOrders/loadSingle$';
const resetSingle$ = 'recurringOrders/resetSingle$';
const fetchActiveOrdersFromRecurringRule$ = 'recurringOrders/fetchActiveOrdersFromRecurringRule$';

// @effect Creators
export const openRecurringOrderEditModal = (payload) => ({
  type: openEditModal$,
  payload,
});

export const closeRecurringOrderEditModal = (payload) => ({
  type: closeEditModal$,
  payload,
});

export const fetchActiveOrdersFromRecurringRule = (payload) => ({
  type: fetchActiveOrdersFromRecurringRule$,
  payload,
});

export const fetchRecurringOrder = (payload) => ({
  type: fetchRecurringOrder$,
  payload,
});

export const resetRecurringOrder = (payload) => ({
  type: resetSingle$,
  payload,
});

export const openRecurringOrderDetailModal = (payload) => ({
  type: openDetailModal$,
  payload,
});

export const closeRecurringOrderDetailModal = (payload) => ({
  type: closeDetailModal$,
  payload,
});

// Helpers
export const fetchRecurringOrderInfo = (id) => {
  return http.get(`${config.API_URL}mercury/recurring_orders/${id}/`);
};

export const fetchRecurringOrderActiveOrders = (id) => {
  return http.getAll(`${config.API_URL}recurring_orders/${id}/details/`);
};

// Workers

function* openEditModal({ payload }) {
  const url = `/recurring-orders/${payload.id}/edit/`;
  yield call(push, { pathname: url });
}

function* closeEditModal({ payload }) {
  const url = `/recurring-orders/${payload.id}/`;

  yield call(replace, { pathname: url });
}

function* handleFetchActiveOrdersFromRecurringRule({ payload }) {
  yield put(requestActiveOrders());
  try {
    const activeOrders = yield call(fetchRecurringOrderActiveOrders, payload.id);
    yield put(doneActiveOrders(activeOrders));
  } catch (error) {
    yield put(cancelRequestActiveOrders(error));
  } finally {
    if (yield cancelled()) {
      yield put(cancelRequestActiveOrders());
    }
  }
}

function* handleFetchRecurringOrder({ id }) {
  yield put(requestSingle());
  try {
    const recurringOrder = yield call(fetchRecurringOrderInfo, id);
    yield put(doneSingle(recurringOrder));
  } catch (err) {
    yield put(cancelSingle(err));
  } finally {
    if (yield cancelled()) {
      yield put(cancelSingle());
    }
  }
}

function* resetSingle({ payload }) {
  yield put(removeSingle());
}

function* handleFetchOneRecurringOrder({ payload }) {
  const fetchSingleTask = yield fork(handleFetchRecurringOrder, payload);
  yield take(resetSingle$, resetSingle);
  yield cancel(fetchSingleTask);
}

function* openDetailModal({ payload }) {
  const url = `/recurring-orders/${payload.id}`;
  yield call(push, { pathname: url });
}

function* closeDetailModal({ payload }) {
  const { action } = payload.history;

  if (action === 'PUSH') {
    yield call(history.goBack);
    return;
  }

  yield call(history.push, '/');
}

// Watchers
export function* watchRecurringOrders() {
  yield takeLatest(openEditModal$, openEditModal);
  yield takeLatest(closeEditModal$, closeEditModal);
  yield takeLatest(fetchRecurringOrder$, handleFetchOneRecurringOrder);
  yield takeLatest(fetchActiveOrdersFromRecurringRule$, handleFetchActiveOrdersFromRecurringRule);
  yield takeLatest(openDetailModal$, openDetailModal);
  yield takeLatest(closeDetailModal$, closeDetailModal);
}
